import Typography, { TypographyProps } from '@mui/material/Typography';
import theme from '../../styles/theme';

export interface GradientTypographyProps extends TypographyProps {
  gradientColor: string;
  component?: React.ElementType;
}

export function GradientTypography(props: GradientTypographyProps) {
  const { gradientColor, ...rest } = props;
  const sections = gradientColor.split('.');
  const background: string = sections.reduce(
    (prev, section) => prev[`${section}`],
    theme.palette,
  ) as unknown as string;
  const shadow = ['primary', 'secondary', 'warning', 'error', 'info'].includes(
    sections[0],
  )
    ? `drop-shadow(${theme.shadowsHard[`${sections[0]}Elevation1`]})`
    : undefined;
  return (
    <Typography
      {...rest}
      sx={{
        ...props.sx,
        background,
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
        filter: shadow,
      }}
    >
      {props.children}
    </Typography>
  );
}
